import React, { useEffect, useRef, useState } from "react";
import styles from "./Location.module.css";
import active from "../../assets/activeIcon.png";
import inactive from "../../assets/InactiveIcon.png";
import { List } from "antd";
import { ImLocation } from "react-icons/im";
import { FiSearch } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AntdDropdown } from "../../components";
import { useDispatch, useSelector } from 'react-redux';

import LocationMiddleware from "../../store/Middlewares/LocationMiddleware";

function Location() {
  const dispatch = useDispatch();
  const [search, setsearch] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [SelectedStatus, setSelectedStatus] = useState('');

  const activeLocations = useSelector(state => state.LocationReducer.ActiveLocations)
  const activeLocationsPagination = useSelector(state => state.LocationReducer.ActiveLocationsPagination);

  console.log('activeLocations', activeLocations)

  useEffect(() => {
    getActiveLocations();
    // getLanguage();
  }, [])

  const getActiveLocations = () => {
    let data = {
      search: search,
      Status: SelectedStatus,
      next_page_url: undefined
    }
    dispatch(LocationMiddleware.getActiveLocations(data))
  }

  const onPressLoadMore = () => {
    let data = {
      search: search,
      Status: SelectedStatus,
      next_page_url: activeLocationsPagination?.links?.next,
    };
    dispatch(LocationMiddleware.getActiveLocations(data));
  };

  const loadMore =
    activeLocationsPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;

  const renderItem = (item) => {
    
    return (
      <div
        className={styles.location_item}
        onClick={() =>
          navigate("/contractorHome/Location/LocationDetails", { state: { data: item } })
        }
      >
        <div className={styles.flex}>
          <ImLocation size={35} color={"#f6921e"} />
          <div className={styles.heading_view}>
            <h1 className={styles.heading}>{item?.cleaner_name}</h1>
            <text className={styles.span}>{item?.location?.address}</text>
          </div>
        </div>
        <img
          src={item?.status == 'pending'  ? inactive :  active}
          className={styles.activeIcon}
        />
      </div>
    );
  };
  const handleChange = value => {
    setSelectedStatus(value)
    // console.log('dropdown',value);
  };

  return (
    <div className={styles.home_mainContainer}>
      <h1 className={styles.main_heading}>{t("Location")}</h1>

      <div className={styles.filter_view}>
        <div style={{ width: '90%', margin: '12px 10px 12px 0px', }}>
          <input
            placeholder={t("Search")}
            onChange={(e) => setsearch(e.target.value)}
            className={styles.search_input}
          />
        </div>
        <div className={styles.flex} style={{ margin: '10px 0px' }}>
          <div>
            <AntdDropdown
              name={'Status'}
              // label={'Role'}
              className={'yellow_border_class'}
              onChange={handleChange}
              options={[{ value: 'Working', option: `${t("Working")}` },
              { value: 'Pending', option: `${t("Pending")}` }]}
              style={{ width: '200px', height: '20px', borderColor: 'red' }}
            />
          </div>
          <div>
            <button onClick={() => getActiveLocations()} className={styles.search_button}>
              <FiSearch size={20} color={"#fff"} />
            </button>
          </div>
        </div>
      </div>
      <List dataSource={activeLocations} loadMore={loadMore} renderItem={renderItem} />
    </div>
  );
}

export default Location;
